export const GET_KITCHENWAREDATA_REQUEST = "GET_KITCHENWAREDATA_REQUEST";
export const GET_KITCHENWAREDATA_SUCCESS = "GET_KITCHENWAREDATA_SUCCESS";
export const GET_KITCHENWAREDATA_FAILURE = "GET_KITCHENWAREDATA_FAILURE";
